<div class="global-filter-container" >
  <form [formGroup]="filterForm" class="filter-wrapper">
    <mat-form-field floatLabel="always" *ngIf="filterVisibility.plant">
      <mat-label class="custom-mat-label">Plant</mat-label>
      <mat-select
        [class.expanded]="filterIconFlag?.sc_node_code"
        ngDefaultControl
        (openedChange)="handleOpenedChange($event, 'sc_node_code')"
        formControlName="sc_node_code"
        multiple
        [panelClass]="'global-custom-select'"
        placeholder="Select Plant"
        [formControl]="globalFilters.sc_node_code.formControl"
      >
        <mat-option>
          <ngx-mat-select-search
            [formControl]="globalFilters.sc_node_code.filterCtrl"
            noEntriesFoundLabel="No entries found"
            closeIcon="x"
            placeholderLabel="Search"
          ></ngx-mat-select-search>
        </mat-option>
        <mat-option #allSelectedPlant (click)="toggleAllSelection('sc_node_code', allSelectedPlant)" [value]="'__all__'"> Select All </mat-option>
        <mat-option *ngFor="let sc_node_code of globalFilters.sc_node_code.filtered | async" (click)="togglePerOne('sc_node_code', allSelectedPlant)" [value]="sc_node_code">
          {{ sc_node_code }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field floatLabel="always" *ngIf="filterVisibility.warehouse">
      <mat-label class="custom-mat-label">Warehouse</mat-label>
      <mat-select
        [class.expanded]="filterIconFlag?.demand_node_code"
        ngDefaultControl
        (openedChange)="handleOpenedChange($event, 'demand_node_code')"
        formControlName="demand_node_code"
        multiple
        [panelClass]="'global-custom-select'"
        placeholder="Select Warehouse"
        [formControl]="globalFilters.demand_node_code.formControl"
      >
        <mat-option>
          <ngx-mat-select-search
            [formControl]="globalFilters.demand_node_code.filterCtrl"
            noEntriesFoundLabel="No entries found"
            closeIcon="x"
            placeholderLabel="Search"
          ></ngx-mat-select-search>
        </mat-option>
        <mat-option #allSelectedWarehouse (click)="toggleAllSelection('demand_node_code', allSelectedWarehouse)" [value]="'__all__'">Select All </mat-option>
        <mat-option *ngFor="let demand_node_code of globalFilters.demand_node_code.filtered | async" (click)="togglePerOne('demand_node_code', allSelectedWarehouse)" [value]="demand_node_code">
          {{ demand_node_code }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field floatLabel="always" *ngIf="filterVisibility.order_types">
      <mat-label class="custom-mat-label">Order Types</mat-label>
      <mat-select
        [class.expanded]="filterIconFlag?.norm_type"
        ngDefaultControl
        (openedChange)="handleOpenedChange($event, 'norm_type')"
        formControlName="norm_type"
        multiple
        [panelClass]="'global-custom-select'"
        placeholder="Select Order Types"
        [formControl]="globalFilters.norm_type.formControl"
      >
        <mat-option>
          <ngx-mat-select-search
            [formControl]="globalFilters.norm_type.filterCtrl"
            noEntriesFoundLabel="No entries found"
            closeIcon="x"
            placeholderLabel="Search"
          ></ngx-mat-select-search>
        </mat-option>
        <mat-option #allSelectedOrderTypes (click)="toggleAllSelection('norm_type', allSelectedOrderTypes)" [value]="'__all__'"> Select All </mat-option>
        <mat-option *ngFor="let norm_type of globalFilters.norm_type.filtered | async" (click)="togglePerOne('norm_type', allSelectedOrderTypes)" [value]="norm_type">
          {{ norm_type }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field floatLabel="always" *ngIf="filterVisibility.classification">
      <mat-label class="custom-mat-label">Classification</mat-label>
      <mat-select
        [class.expanded]="filterIconFlag?.classification"
        ngDefaultControl
        (openedChange)="handleOpenedChange($event, 'classification')"
        formControlName="classification"
        multiple
        [panelClass]="'global-custom-select'"
        placeholder="Select Classification"
        [formControl]="globalFilters.classification.formControl"
      >
        <mat-option>
          <ngx-mat-select-search
            [formControl]="globalFilters.classification.filterCtrl"
            noEntriesFoundLabel="No entries found"
            closeIcon="x"
            placeholderLabel="Search"
          ></ngx-mat-select-search>
        </mat-option>
        <mat-option #allSelectedClassification (click)="toggleAllSelection('classification', allSelectedClassification)" [value]="'__all__'">Select All </mat-option>
        <mat-option *ngFor="let classification of globalFilters.classification.filtered | async" (click)="togglePerOne('classification', allSelectedClassification)" [value]="classification">
          {{ classification }}
          </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field floatLabel="always" *ngIf="filterVisibility.part_no">
      <mat-label class="custom-mat-label">Part No</mat-label>
      <mat-select
        [class.expanded]="filterIconFlag?.sku_code"
        ngDefaultControl
        (openedChange)="handleOpenedChange($event, 'sku_code')"
        formControlName="sku_code"
        multiple
        [panelClass]="'global-custom-select'"
        placeholder="Select Part No"
        [formControl]="globalFilters.sku_code.formControl"
      >
        <mat-option>
          <ngx-mat-select-search
            [formControl]="globalFilters.sku_code.filterCtrl"
            noEntriesFoundLabel="No entries found"
            closeIcon="x"
            placeholderLabel="Search"
          ></ngx-mat-select-search>
        </mat-option>
        <mat-option #allSelectedPartNo (click)="toggleAllSelection('sku_code', allSelectedPartNo)" [value]="'__all__'">Select All </mat-option>
        <mat-option
          *ngFor="let sku_code of globalFilters.sku_code.filtered | async" (click)="togglePerOne('sku_code', allSelectedPartNo)" [value]="sku_code">
          {{ sku_code }}
          </mat-option >
      </mat-select>
    </mat-form-field>
    <mat-form-field floatLabel="always" *ngIf="filterVisibility.date_range">
      <mat-label class="custom-mat-label">Time Period</mat-label>
      <mat-select
        [class.expanded]="filterIconFlag?.date_range"
        ngDefaultControl
        (openedChange)="handleOpenedChange($event, 'date_range')"
        formControlName="date_range"
        multiple
        [panelClass]="'global-custom-select'"
        placeholder="Select Time Period"
        [formControl]="globalFilters.date_range.formControl"
      >
        <mat-option>
          <ngx-mat-select-search
            [formControl]="globalFilters.date_range.filterCtrl"
            noEntriesFoundLabel="No entries found"
            closeIcon="x"
            placeholderLabel="Search"
          ></ngx-mat-select-search>
        </mat-option>
        <mat-option #allSelectedDaterange (click)="toggleAllSelection('date_range', allSelectedDaterange)" [value]="'__all__'">Select All </mat-option>
        <mat-option *ngFor="let date_range of globalFilters.date_range.filtered | async" (click)="togglePerOne('date_range', allSelectedDaterange)" [value]="date_range">
          {{ date_range }}
          </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field floatLabel="always" *ngIf="filterVisibility.sales_channel_code">
      <mat-label class="custom-mat-label">Customer</mat-label>
      <mat-select
        [class.expanded]="filterIconFlag?.sales_channel_code"
        ngDefaultControl
        (openedChange)="handleOpenedChange($event, 'sales_channel_code')"
        formControlName="sales_channel_code"
        multiple
        [panelClass]="'global-custom-select'"
        placeholder="Select Customer"
        [formControl]="globalFilters.sales_channel_code.formControl"
      >
        <mat-option>
          <ngx-mat-select-search
            [formControl]="globalFilters.sales_channel_code.filterCtrl"
            noEntriesFoundLabel="No entries found"
            closeIcon="x"
            placeholderLabel="Search"
          ></ngx-mat-select-search>
        </mat-option>
        <mat-option #allSelectedCustomer (click)="toggleAllSelection('sales_channel_code', allSelectedCustomer)" [value]="'__all__'">Select All </mat-option>
        <mat-option *ngFor="let customer of globalFilters.sales_channel_code.filtered | async" (click)="togglePerOne('sales_channel_code', allSelectedCustomer)" [value]="customer">
          {{ customer }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div class="d-flex align-items-baseline clear-filter">
      <span class="filter-count">{{filterCount}}</span>
      <img src="assets/images/clear_filter.svg" title="Clear All" (click)="onClearFilter()">
    </div>
  </form>
</div>
